// interpretTraining.js

const normalizeLanguage = (language) => String(language || 'es').toLowerCase().startsWith('en') ? 'en' : 'es';

export const interpretTTE = (tteValue, language = 'es') => {
  const lang = normalizeLanguage(language);
  if (lang === 'en') {
    if (tteValue >= 0 && tteValue < 1) return "The session was not intense enough.";
    if (tteValue >= 1 && tteValue < 2) return "It triggered minor physiological adaptations.";
    if (tteValue >= 2 && tteValue < 3) return "Enough to maintain current fitness.";
    if (tteValue >= 3 && tteValue < 4) return "Significant impact, performance improvement.";
    if (tteValue >= 4 && tteValue < 5) return "Very intense and effective.";
    if (tteValue === 5) return "Extremely intense, possible overtraining.";
    return "Unrecognized TTE value.";
  }

  if (tteValue >= 0 && tteValue < 1) return "La sesión no fue lo suficientemente intensa.";
  if (tteValue >= 1 && tteValue < 2) return "Provocó algunas adaptaciones fisiológicas menores.";
  if (tteValue >= 2 && tteValue < 3) return "Suficiente para mantener la condición física actual.";
  if (tteValue >= 3 && tteValue < 4) return "Impacto significativo, mejora del rendimiento.";
  if (tteValue >= 4 && tteValue < 5) return "Muy intensa y efectiva.";
  if (tteValue === 5) return "Extremadamente intensa, posible sobreentrenamiento.";
  return "Valor de TTE no reconocido.";
};

export const interpretTAE = (taeValue, language = 'es') => {
  const lang = normalizeLanguage(language);
  if (lang === 'en') {
    if (taeValue >= 0 && taeValue < 1) return "Minimal impact on the anaerobic system.";
    if (taeValue >= 1 && taeValue < 2) return "Moderate contribution to anaerobic training.";
    if (taeValue >= 2 && taeValue < 3) return "Significant impact on the anaerobic system.";
    if (taeValue >= 3 && taeValue < 4) return "Very intense and effective for the anaerobic system.";
    if (taeValue >= 4 && taeValue <= 5) return "Extremely intense, possible overtraining.";
    return "Unrecognized TEA value.";
  }

  if (taeValue >= 0 && taeValue < 1) return "Impacto mínimo en el sistema anaeróbico.";
  if (taeValue >= 1 && taeValue < 2) return "Contribución moderada al entrenamiento anaeróbico.";
  if (taeValue >= 2 && taeValue < 3) return "Impacto significativo en el sistema anaeróbico.";
  if (taeValue >= 3 && taeValue < 4) return "Muy intensa y efectiva para el sistema anaeróbico.";
  if (taeValue >= 4 && taeValue <= 5) return "Extremadamente intensa, posible sobreentrenamiento.";
  return "Valor de TEA no reconocido.";
};
